/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VesselShowHomeContentQueryVariables = {
    slug: string;
};
export type VesselShowHomeContentQueryResponse = {
    readonly vesselShow: {
        readonly slug: string;
        readonly voyageItems: ReadonlyArray<{
            readonly slug: string;
            readonly " $fragmentRefs": FragmentRefs<"ShowPageListItem_listItem">;
        }>;
    };
};
export type VesselShowHomeContentQuery = {
    readonly response: VesselShowHomeContentQueryResponse;
    readonly variables: VesselShowHomeContentQueryVariables;
};



/*
query VesselShowHomeContentQuery(
  $slug: String!
) {
  vesselShow(slug: $slug) {
    slug
    voyageItems {
      slug
      ...ShowPageListItem_listItem
      id
    }
    id
  }
}

fragment Badge_data on Badge {
  type
}

fragment ContactLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  imageUrl
}

fragment ContainerLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  badge {
    ...Badge_data
  }
}

fragment ItemImage_data on Image {
  url
  alt
  highlight
  shape
  overlay
  overlayIcon
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment LinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  entitySlug
  ...VoyageLinkCard_data
  ...VesselLinkCard_data
  ...ShipmentLinkCard_data
  ...ContainerLinkCard_data
  ...ContactLinkCard_data
}

fragment LinkSet_data on LinkSet {
  title
  inline
  links {
    key
    type
    ...LinkCard_data
  }
}

fragment SemanticLine_data on SemanticLine {
  parts {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment ShipmentLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  badge {
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
}

fragment ShowPageListItem_listItem on ListItem {
  slug
  title
  isArchived
  itemType
  stickyNoteContent
  image {
    ...ItemImage_data
  }
  path
  statuses {
    key
    value {
      ...SemanticString_data
    }
  }
  stages {
    key
    status
    label
    value
  }
  badges {
    key
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  linkSets {
    key
    ...LinkSet_data
  }
  keyFields {
    key
    ...KeyField_data
  }
  children {
    slug
    title
    itemType
    badges {
      key
      ...Badge_data
    }
    id
  }
}

fragment VesselLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
}

fragment VoyageLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  voyageEta {
    ...SemanticString_data
  }
  voyageEtd {
    ...SemanticString_data
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badges",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "SemanticLine",
  "kind": "LinkedField",
  "name": "lines",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "parts",
      "plural": true,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VesselShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Vessel",
        "kind": "LinkedField",
        "name": "vesselShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListItem",
            "kind": "LinkedField",
            "name": "voyageItems",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShowPageListItem_listItem"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VesselShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Vessel",
        "kind": "LinkedField",
        "name": "vesselShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListItem",
            "kind": "LinkedField",
            "name": "voyageItems",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isArchived",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stickyNoteContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highlight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shape",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overlay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overlayIcon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Status",
                "kind": "LinkedField",
                "name": "statuses",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stage",
                "kind": "LinkedField",
                "name": "stages",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkSet",
                "kind": "LinkedField",
                "name": "linkSets",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Link",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "title",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "meta",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entitySlug",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "voyageEta",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "voyageEtd",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Badge",
                        "kind": "LinkedField",
                        "name": "badge",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyField",
                "kind": "LinkedField",
                "name": "keyFields",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ListItem",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ab29373bd24935c372e007755bfbdc1e",
    "id": null,
    "metadata": {},
    "name": "VesselShowHomeContentQuery",
    "operationKind": "query",
    "text": "query VesselShowHomeContentQuery(\n  $slug: String!\n) {\n  vesselShow(slug: $slug) {\n    slug\n    voyageItems {\n      slug\n      ...ShowPageListItem_listItem\n      id\n    }\n    id\n  }\n}\n\nfragment Badge_data on Badge {\n  type\n}\n\nfragment ContactLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  imageUrl\n}\n\nfragment ContainerLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  badge {\n    ...Badge_data\n  }\n}\n\nfragment ItemImage_data on Image {\n  url\n  alt\n  highlight\n  shape\n  overlay\n  overlayIcon\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment LinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  entitySlug\n  ...VoyageLinkCard_data\n  ...VesselLinkCard_data\n  ...ShipmentLinkCard_data\n  ...ContainerLinkCard_data\n  ...ContactLinkCard_data\n}\n\nfragment LinkSet_data on LinkSet {\n  title\n  inline\n  links {\n    key\n    type\n    ...LinkCard_data\n  }\n}\n\nfragment SemanticLine_data on SemanticLine {\n  parts {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment ShipmentLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  badge {\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n}\n\nfragment ShowPageListItem_listItem on ListItem {\n  slug\n  title\n  isArchived\n  itemType\n  stickyNoteContent\n  image {\n    ...ItemImage_data\n  }\n  path\n  statuses {\n    key\n    value {\n      ...SemanticString_data\n    }\n  }\n  stages {\n    key\n    status\n    label\n    value\n  }\n  badges {\n    key\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  linkSets {\n    key\n    ...LinkSet_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n  children {\n    slug\n    title\n    itemType\n    badges {\n      key\n      ...Badge_data\n    }\n    id\n  }\n}\n\nfragment VesselLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n}\n\nfragment VoyageLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  voyageEta {\n    ...SemanticString_data\n  }\n  voyageEtd {\n    ...SemanticString_data\n  }\n}\n"
  }
};
})();
(node as any).hash = '67960aa53915e10b725b69d143fa43fd';
export default node;
